export default "__VITE_PUBLIC_ASSET__466d291d__"